import { render, staticRenderFns } from "./MsgDetail.vue?vue&type=template&id=3d179e4d&scoped=true&"
import script from "./MsgDetail.vue?vue&type=script&lang=js&"
export * from "./MsgDetail.vue?vue&type=script&lang=js&"
import style0 from "./MsgDetail.vue?vue&type=style&index=0&id=3d179e4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d179e4d",
  null
  
)

export default component.exports